/**
 * Portal chrome layout — wraps every portal screen with the sidebar + topbar
 * (desktop) or topbar + bottom nav (phone). Children render via <Slot>.
 */
import { Redirect, Slot, usePathname } from 'expo-router'
import { XStack, YStack } from 'tamagui'

import { useResponsive } from '../../src/lib/responsive'
import { Sidebar } from '../../src/app/Sidebar'
import { TopBar } from '../../src/app/TopBar'
import { BottomNav } from '../../src/app/BottomNav'
import { isComingSoon, ROUTE_TITLE } from '../../src/app/nav'
import { useApp } from '../../src/i18n'
import { useDocumentTitle } from '../../src/lib/useDocumentTitle'

export default function PortalLayout() {
  const { isPhone } = useResponsive()
  const pathname = usePathname()
  const { l } = useApp()

  // Browser tab title for static routes (reuses the topbar's ROUTE_TITLE map).
  // Detail routes (/news/[id], /post/[id]) aren't in the map → skip here and let
  // those screens set the article/post title themselves.
  const titleKey = ROUTE_TITLE[pathname]
  useDocumentTitle(titleKey ? l(titleKey) : null)

  return (
    <XStack flex={1} backgroundColor="$background">
      {!isPhone && <Sidebar />}

      <YStack flex={1} minWidth={0}>
        <TopBar isPhone={isPhone} />
        <YStack flex={1} backgroundColor="$bgLayout">
          {/* not-ready sections are off-limits — bounce to /home even on a
              direct URL hit (covers in-app pushes too). See nav.ts. */}
          {isComingSoon(pathname) ? <Redirect href="/home" /> : <Slot />}
        </YStack>
        {isPhone && <BottomNav />}
      </YStack>
    </XStack>
  )
}
